<template>
  <Page title="Lista wydarzeń">
    <UserEventList />
  </Page>
</template>

<script>
import Page from "@/components/Elements/Page";
import ViewMixin from "@/mixins/View";
import UserEventList from "@/components/Event/UserEventList";

export default {
  name: "EventListView",
  components: {
    Page,
    UserEventList
  },
  mixins: [ViewMixin]
};
</script>
